(function(){
  'use strict';

  function paidChangesLocked(){
    return document.documentElement.getAttribute('data-sk-paid-changes-locked') === 'true';
  }

  function premiumMealNames(){
    var names=[];
    document.querySelectorAll('#sw-meal-grid .sw-card').forEach(function(card){
      var badge=card.querySelector('.sw-upgrade-badge:not(.available)');
      if(!badge || !/premium\s*upgrade/i.test(String(badge.textContent||''))) return;
      var title=card.querySelector('.sw-card-name,.sw-card-title,h3');
      var name=String(title && title.textContent || '').trim();
      if(name && names.indexOf(name)===-1) names.push(name);
    });
    return names;
  }

  function isPaidSidebarItem(item){
    if(!item) return false;
    var nameNode=item.querySelector('.sw-sb-name');
    var variantNode=item.querySelector('.sw-sb-variant');
    var name=String(nameNode && nameNode.textContent || '').trim();
    var variant=String(variantNode && variantNode.textContent || '').trim();
    if(/(double\s*protein|\+\$)/i.test(variant)) return true;
    return premiumMealNames().indexOf(name)!==-1;
  }

  function disablePaidSidebarControls(){
    if(!paidChangesLocked()) return;
    document.querySelectorAll('#sw-sb-body .sw-sb-item,#sw-sheet-items .sw-sb-item').forEach(function(item){
      if(!isPaidSidebarItem(item)) return;
      item.classList.add('sk-paid-sidebar-item');
      item.querySelectorAll('.sw-sb-stepper button,.sw-sb-rm').forEach(function(button){
        button.disabled=true;
        button.setAttribute('aria-disabled','true');
        button.setAttribute('title','Locked because this box is already paid');
        button.classList.add('sk-paid-locked-control');
      });
    });
  }

  function flashBanner(){
    var banner=document.getElementById('sk-first-paid-lock-banner');
    if(!banner) return;
    banner.scrollIntoView({behavior:'smooth',block:'center'});
    banner.style.boxShadow='0 0 0 3px rgba(184,92,42,.18)';
    window.setTimeout(function(){ banner.style.boxShadow=''; },900);
  }

  function blockPaidStepper(event){
    if(!paidChangesLocked()) return;
    var button=event.target && event.target.closest
      ? event.target.closest('.sw-sb-stepper button,.sw-sb-rm')
      : null;
    if(!button) return;
    var container=button.closest('#sw-sb-body,#sw-sheet-items');
    if(!container) return;
    var item=button.closest('.sw-sb-item');
    if(!isPaidSidebarItem(item)) return;

    event.preventDefault();
    event.stopPropagation();
    if(typeof event.stopImmediatePropagation==='function') event.stopImmediatePropagation();
    button.disabled=true;
    button.setAttribute('aria-disabled','true');
    button.setAttribute('title','Locked because this box is already paid');
    flashBanner();
  }

  function observeList(id){
    var node=document.getElementById(id);
    if(!node || typeof MutationObserver!=='function') return;
    new MutationObserver(function(){
      window.setTimeout(disablePaidSidebarControls,0);
    }).observe(node,{childList:true,subtree:true,characterData:true});
  }

  function install(){
    document.addEventListener('click',blockPaidStepper,true);
    observeList('sw-sb-body');
    observeList('sw-sheet-items');
    disablePaidSidebarControls();

    if(typeof MutationObserver==='function'){
      new MutationObserver(function(){
        if(paidChangesLocked()) window.setTimeout(disablePaidSidebarControls,0);
      }).observe(document.documentElement,{attributes:true,attributeFilter:['data-sk-paid-changes-locked']});
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',install,{once:true});
  else install();
})();
